import React, {useEffect, useRef, useState} from 'react';
import "./Conversation.sass"
import renderHTML from 'react-render-html';
import gsap from 'gsap';
import _ from 'lodash';
import DownArrow from './../../../icons/down_arrow.svg';
import UpArrow from './../../../icons/up_arrow.svg';
import ModalPopUp from "../../ui/PopUp/ModalPopUp";
import EnhancedPopUp from "../../ui/PopUp/EnhancedPopUp";
import Button from "../../ui/Button/Button";
import SlideShow from "../../ui/SlideShow/SlideShow";
import apiJSON from "../../../api/apiJSON";

const Conversation = ({data, completed, next}) => {

    const [alert, setAlert] = useState(false);
    const [feedback, setFeedback] = useState(false);
    const [tracking, setTracking] = useState([]);
    const [selectedSlide, setSelectedSlide] = useState(null)
    const [scenario, setScenario] = useState(null);
    const [choiceSet, setChoiceSet] = useState(null);
    const [says, setSays] = useState(null);
    const [thinks, setThinks] = useState(null);
    const [selectedChoice, setSelectedChoice] = useState(null);
    const [showDropDown, setShowDropDown] = useState(false)

    const jsonData = apiJSON.get(data);
    const {scenarios} = jsonData;

    useEffect(() => {
        setScenario(scenarios[0]);
        setSelectedSlide(scenarios[0].person.slide)
        setChoiceSet(scenarios[0].choiceSets[0]);
    }, []);

    useEffect(() => {
        updateChoiceSet();
    }, [choiceSet]);

    useEffect(() => {
        if (!feedback) return;
        if (feedback.person) {
            setSelectedSlide(feedback.person.slide);
            feedback.person.says ? setSays(feedback.person.says) : setSays(null);
            feedback.person.thinks ? setThinks(feedback.person.thinks) : setThinks(null);
        }
        if (feedback.body) {
            gsap.set (".feedback-panel",{visibility: "visible"})
            gsap.from(".feedback-panel", {y: 1000, ease: "expo.out"})
        }
    }, [feedback])


    const handleChoice = (choice, event) => {
        console.log("handleChoice(", choice, event.target.id, ")")

        if (choice) {
            console.log("handleChoice(" + choice.label + ")");
            console.log(choice.linkage)
            setSelectedChoice(choice);
        }

        let t = tracking.slice();
        t.push(event.target.id);
        setTracking(t);

        if (!choice.feedback) {
            advance(choice);
        } else {
            setFeedback(choice.feedback);
        }
    }

    const isAttempted = (id) => {
        return (_.indexOf(tracking, id) >= 0)
    }

    const getChoiceSet = (id) => {
        return _.find(scenario.choiceSets, function (o) {
            return o.id === id;
        })
    }

    const advance = (choice) => {
        console.log("Conversation advance(", choice, ")");
        if (!choice) {
            choice = selectedChoice;
            setFeedback(null);
        }
        //console.log("choice.linkage:" + choice.linkage);
        if (choice.alert && !alert) {
            let a = _.find(scenario.alerts, function (o) {
                return o.id === choice.alert
            });
            setAlert(a);
            return;
        }
        switch (choice.linkage) {
            case "resetChoiceSet":
                break;
            case "endScenario":
                completed();
                next();
                break;
            default:
                let cs = getChoiceSet(choice.linkage)
                setChoiceSet(cs);
        }
    }

    const alertHide = () => {
        advance();
        setAlert(null);
    }

    const updateChoiceSet = () => {
        //console.log("updateChoiceSet()")
        setSelectedChoice((null));
        setTracking([]);

        let d = 0;
        if (choiceSet && choiceSet.person) {
            setSelectedSlide(choiceSet.person.slide);
            choiceSet.person.says ? setSays(choiceSet.person.says) : setSays(null);
            choiceSet.person.thinks ? setThinks(choiceSet.person.thinks) : setThinks(null);
        } else {
            setSays(null);
            setThinks(null);
        }
        gsap.from(".choice-panel", {x: 1600, ease: "expo.out", delay: d})
    }

    const toggleDropDown = () => {
        setShowDropDown(!showDropDown);
    }

    const handleDropDownSelect = (id) => {
        setChoiceSet(_.find(scenario.choiceSets, (o) => {
            return o.id === id
        }));
        toggleDropDown();
    }


    return (
        <div className="Conversation">
            {thinks && <div className="thought-balloon">
                {renderHTML(thinks)}
            </div>}
            {says && <div className="speech-balloon">
                {renderHTML(says)}
            </div>}
            {scenario && <div className="slideshow-holder">
                <SlideShow data={scenario.person}
                           selectedSlide={selectedSlide}/>
            </div>}

            {(feedback && feedback.body) &&
            <div className="feedback-panel"
                 style={{
                     "visibility": "hidden"
                 }}>
                {feedback.title &&
                <div className="feedback-title">
                    {feedback.title}
                </div>}
                {feedback.title &&
                <div className="feedback-divider"/>
                }
                {feedback.body &&
                <div className='feedback-body'>
                    {renderHTML(feedback.body)}
                </div>
                }
                <Button data={"Continue"}
                        callback={advance}/>
            </div>}
            {choiceSet &&
            <div className="choice-panel">
                {scenario.instructions &&
                <div className="choice-panel-title">
                    {scenario.instructions}
                </div>
                }
                {
                    scenario.instructions &&
                    <div className="choice-panel-divider"/>
                }
                <div className="choice-group">
                    {choiceSet.choices.map((choice, index) => (
                        <div key={"choice" + index}
                             id={choiceSet.id + "_choice" + index}
                             className={"choice-button " + (isAttempted(choiceSet.id + "_choice" + index) ? "disabled" : "")}
                             onClick={((e) => {
                                 handleChoice(choice, e)
                             })}>
                            {renderHTML(choice.label)}
                        </div>
                    ))}
                </div>
            </div>}
            {alert &&
            <EnhancedPopUp data={alert}
                           onHide={alertHide}/>
            }
            {
                (scenario) && <div className="dropdown-container">
                    <div className="test-table-button"
                         onClick={toggleDropDown}>
                        {choiceSet.id}
                        <img src={showDropDown ? UpArrow : DownArrow}
                             style={{width: 20}}/>
                    </div>
                    {showDropDown && (
                        scenario.choiceSets.map((cs, index) => (
                            <div className="dropdown-item"
                                 key={"choice" + index}
                                 onClick={() => {
                                     handleDropDownSelect(cs.id)
                                 }}>
                                {cs.id}
                            </div>
                        ))
                    )}

                </div>
            }
        </div>
    );
}
;

export default Conversation;